<template>
  <v-container class="px-0">
    <h3>Hide filters</h3>
    <v-row>
      <v-col cols="12">
        <service-status-multi-select
          :outlined="outlinedInputs"
          v-model="statuses"
          @change="onStatusChange"
        ></service-status-multi-select>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>{{ filters }}--{{ value }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ServiceStatusMultiSelect from "../../../shared/ServiceStatusMultiSelect.vue";
export default {
  name: "items-list-hide-filters",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    ServiceStatusMultiSelect,
  },

  data() {
    return {
      debug: false,
      statuses:
        this.value && this.value.statusId ? [...this.value.statusId] : [],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    filters() {
      const f = {};
      if (this.statuses.length) {
        f.statusId = this.statuses;
      }
      return f;
    },
  },

  watch: {
    value(newVal) {
      this.statuses = newVal && newVal.statusId ? [...newVal.statusId] : [];
    },
  },

  methods: {
    onStatusChange() {
      this.change();
    },
    change() {
      this.$emit("input", this.filters);
      this.$emit("change", this.filters);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ItemsListHideFilters.vue